module.exports = __webpack_public_path__ + "img/uhsp_logo.2daa6476.jpg";